import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import './ThirdPartyServices.css';

const technologies = {
  "APIs": [
    { 
      name: "Postman",
      logo: "/assets/tech-logos/postman-external.svg",
      fallbackLogo: "/assets/tech-logos/postman.svg"
    },
    { 
      name: "Firebase",
      logo: "/assets/tech-logos/firebase-external.svg",
      fallbackLogo: "/assets/tech-logos/firebase.svg"
    },
    { 
      name: "GraphQL",
      logo: "/assets/tech-logos/graphql-external.svg",
      fallbackLogo: "/assets/tech-logos/graphql.svg"
    },
    { 
      name: "REST",
      logo: "/assets/tech-logos/rest-external.svg",
      fallbackLogo: "/assets/tech-logos/rest.svg"
    }
  ],
  "Social": [
    { 
      name: "Facebook",
      logo: "/assets/tech-logos/facebook-external.svg",
      fallbackLogo: "/assets/tech-logos/facebook.svg"
    },
    { 
      name: "Twitter",
      logo: "/assets/tech-logos/twitter-external.svg",
      fallbackLogo: "/assets/tech-logos/twitter.svg"
    },
    { 
      name: "Instagram",
      logo: "/assets/tech-logos/instagram-external.svg",
      fallbackLogo: "/assets/tech-logos/instagram.svg"
    },
    { 
      name: "Google",
      logo: "/assets/tech-logos/google-external.svg",
      fallbackLogo: "/assets/tech-logos/google.svg"
    },
    { 
      name: "Telegram",
      logo: "/assets/tech-logos/telegram-external.svg",
      fallbackLogo: "/assets/tech-logos/telegram.svg"
    },
    { 
      name: "Twitch",
      logo: "/assets/tech-logos/twitch-external.svg",
      fallbackLogo: "/assets/tech-logos/twitch.svg"
    },
    { 
      name: "LinkedIn",
      logo: "/assets/tech-logos/linkedin-external.svg",
      fallbackLogo: "/assets/tech-logos/linkedin.svg"
    }
  ],
  "Maps": [
    { 
      name: "Google Maps",
      logo: "/assets/tech-logos/googlemaps-external.svg",
      fallbackLogo: "/assets/tech-logos/googlemaps.svg"
    },
    { 
      name: "Waze",
      logo: "/assets/tech-logos/waze.svg",
      fallbackLogo: "/assets/tech-logos/waze.svg"
    },
    { 
      name: "Places API",
      logo: "/assets/tech-logos/places.svg",
      fallbackLogo: "/assets/tech-logos/places.svg"
    },
    { 
      name: "Maps SDK",
      logo: "/assets/tech-logos/mapssdk-external.svg",
      fallbackLogo: "/assets/tech-logos/mapssdk.svg"
    }
  ],
  "Call & SMS": [
    { 
      name: "Twilio",
      logo: "/assets/tech-logos/twilio-external.svg",
      fallbackLogo: "/assets/tech-logos/twilio.svg"
    },
    // { 
    //   name: "Nexmo",
    //   logo: "/assets/tech-logos/nexmo-external.ico",
    //   fallbackLogo: "/assets/tech-logos/nexmo.svg"
    // },
    { 
      name: "Twitch",
      logo: "/assets/tech-logos/twitch-external.svg",
      fallbackLogo: "/assets/tech-logos/twitch.svg"
    },
    { 
      name: "Heroku",
      logo: "/assets/tech-logos/heroku-external.svg",
      fallbackLogo: "/assets/tech-logos/heroku.svg"
    },
    { 
      name: "Agora",
      logo: "/assets/tech-logos/agora.svg",
      fallbackLogo: "/assets/tech-logos/agora.svg"
    }
  ],
  "Emails": [
    { 
      name: "Mailchimp",
      logo: "/assets/tech-logos/mailchimp-external.svg",
      fallbackLogo: "/assets/tech-logos/mailchimp.svg"
    },
    { 
      name: "Brevo",
      logo: "/assets/tech-logos/brevo-external.ico",
      fallbackLogo: "/assets/tech-logos/brevo.svg"
    },
    { 
      name: "Amazon SES",
      logo: "/assets/tech-logos/ses-external.svg",
      fallbackLogo: "/assets/tech-logos/ses.svg"
    },
    { 
      name: "G Suite",
      logo: "/assets/tech-logos/gsuite-external.svg",
      fallbackLogo: "/assets/tech-logos/gsuite.svg"
    },
    { 
      name: "SendGrid",
      logo: "/assets/tech-logos/sendgrid-external.svg",
      fallbackLogo: "/assets/tech-logos/sendgrid.svg"
    }
  ]
};

const ThirdPartyServices = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const handleImageError = (e, fallbackSrc) => {
    if (e.target.src !== fallbackSrc) {
      e.target.src = fallbackSrc;
    }
  };

  return (
    <Box className="third-party-services-section">
      <Container maxWidth="lg">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <Typography variant="h2" className="section-title" gutterBottom>
            THIRD PARTY SERVICES
          </Typography>

          {Object.entries(technologies).map(([category, techs]) => (
            <Box key={category} className="technology-category">
              <Typography variant="h4" className="category-title" gutterBottom>
                {category}
              </Typography>
              <Grid container spacing={3}>
                {techs.map((tech) => (
                  <Grid item xs={6} sm={4} md={3} lg={2} key={tech.name}>
                    <motion.div variants={itemVariants}>
                      <Paper elevation={2} className="technology-card">
                        <img
                          src={tech.logo}
                          alt={tech.name}
                          className="technology-logo"
                          onError={(e) => handleImageError(e, tech.fallbackLogo)}
                        />
                        <Typography variant="subtitle1" className="technology-name">
                          {tech.name}
                        </Typography>
                      </Paper>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </motion.div>
      </Container>
    </Box>
  );
};

export default ThirdPartyServices; 